import { Button, Stack, Typography } from '@dtx-company/design-system/src'
import { FC } from 'react'
import {
  FontDownloadOutlined,
  InsertPhotoOutlined,
  LocalPhoneOutlined,
  SpaceDashboardOutlined
} from '@mui/icons-material'
import { useAddSectionCallbacks } from './AddSection.hooks'
import useTranslation from 'next-translate/useTranslation'

export const AddSection: FC = () => {
  const {
    handleContactLinksOpen,
    handleImageSectionLinkOpen,
    handleTextBoxSectionLinkOpen,
    handleContactCollectionFormOpen
  } = useAddSectionCallbacks()
  const { t } = useTranslation('page')
  return (
    <Stack
      sx={{
        padding: 4,
        mt: 4,
        width: '100%',
        alignItems: 'center'
      }}
      gap={4}
    >
      <Typography variant="subtitleSmall">{t('Nav.AddSection.title')}</Typography>

      <Button
        onClick={handleTextBoxSectionLinkOpen}
        fullWidth
        variant="outlined"
        size="large"
        startIcon={FontDownloadOutlined}
      >
        {t('Nav.AddSection.buttons.textBox')}
      </Button>

      <Button
        onClick={handleContactLinksOpen}
        fullWidth
        variant="outlined"
        size="large"
        startIcon={LocalPhoneOutlined}
      >
        {t('Nav.AddSection.buttons.contactInformation')}
      </Button>

      <Button
        onClick={handleContactCollectionFormOpen}
        fullWidth
        variant="outlined"
        size="large"
        startIcon={SpaceDashboardOutlined}
      >
        {t('Nav.AddSection.buttons.contactCollection')}
      </Button>

      <Button
        onClick={handleImageSectionLinkOpen}
        fullWidth
        variant="outlined"
        size="large"
        startIcon={InsertPhotoOutlined}
      >
        {t('Nav.AddSection.buttons.image')}
      </Button>
    </Stack>
  )
}
